export default class FilterSelect {
    constructor(el, parent) {
        if (!this.set(el, parent)) return;
        this.init();
    }

    set(el, parent) {
        if (!el || !parent) return false;

        this.root = el;
        this.parentEl = parent;
        this.topEl = this.root.querySelector('[filter-select-top]');
        this.listEl = this.root.querySelector('[filter-select-list]');
        this.itemEl = this.root.querySelectorAll('[filter-select-item]');
        this.buttonEl = this.root.querySelectorAll('button');
        this.iconEl = this.root.querySelector('[filter-select-icon]');

        return true;
    }

    init() {
        this.setTopEl();
        this.setItemEl();
    }

    setTopEl() {
        if (!this.topEl) return;

        this.onTop = this.onTopClick.bind(this);
        this.topEl.addEventListener('click', this.onTop);
    }

    setItemEl() {
        if (!this.itemEl) return;

        this.onItem = this.onItemClick.bind(this);
        this.itemEl.forEach(item => {
            item.addEventListener('click', this.onItem);
        });
    }

    onTopClick(event) {
        event.preventDefault();
        event.stopPropagation();

        const { currentTarget } = event;
        this.listEl.classList.toggle('-active');

        const button = currentTarget.querySelector('button');
        const buttonValue = button.getAttribute('products-grid-cat');

        this.resetButtonsActive();
        button.classList.add('-active');
        this.root.classList.toggle('-expanded');
        this.iconEl.classList.toggle('-rotate-180');

        const customChangeEv = new CustomEvent('filter-select-change', {
            detail: {
                value: window.innerWidth > 1024 ? 'all' : buttonValue,
            },
        });
        this.parentEl.dispatchEvent(customChangeEv);
    }

    onItemClick(event) {
        const { innerWidth } = window;

        const { currentTarget } = event;
        const item = currentTarget;
        const value = item.getAttribute('filter-select-item');

        const customChangeEv = new CustomEvent('filter-select-change', {
            detail: {
                value,
            },
        });
        this.parentEl.dispatchEvent(customChangeEv);

        const itemButton = item.querySelector('button');
        const topButton = this.topEl.querySelector('button');

        this.resetButtonsActive();
        itemButton.classList.add('-active');

        if (innerWidth > 1024) return;
        const topButtonClone = topButton.cloneNode(true);
        const itemButtonClone = itemButton.cloneNode(true);

        this.topEl.replaceChild(itemButtonClone, topButton);
        item.replaceChild(topButtonClone, itemButton);

        itemButtonClone.classList.remove('pointer-events-none');
        itemButtonClone.classList.add('lg:pointer-events-auto');
        itemButtonClone.classList.add('-active');

        topButtonClone.classList.add('pointer-events-none');
        topButtonClone.classList.remove('lg:pointer-events-auto');
        topButtonClone.classList.remove('-active');

        const listButtons = this.listEl.querySelectorAll('button');
        listButtons.forEach(listButtonEl => {
            listButtonEl.classList.remove('pointer-events-none');
        });

        this.root
            .querySelector('[filter-select-top] button')
            .scrollIntoViewIfNeeded?.();

        const customEv = new CustomEvent('filter-select-item-swap');
        this.parentEl.dispatchEvent(customEv);
    }

    resetButtonsActive() {
        if (!this.buttonEl) return;
        this.buttonEl.forEach(item => item.classList.remove('-active'));
    }
}
